import { QueryClient } from 'react-query';

export const refetchCustomersQueryMutationOption = (qCl: QueryClient) => ({
  onSuccess: () => qCl.invalidateQueries('FETCH_CUSTOMERS_QUERY'),
});
